import React from "react";
import Paper from "@mui/material/Paper";
import { ProductsList } from "./ProductsList";
import { VendorsList } from "./VendorsList";
import { Loading } from "./Loading";
import { HgProduct, HgVendor } from "../../../../types/taxonomy";
import { ClickAwayListener } from "@mui/material";

interface Props {
  open: boolean;
  loadingProducts: boolean;
  productsList: HgProduct[];
  vendorsList: HgVendor[];
  onViewAllProducts: () => void;
  onClose: () => void;
}

const COMPONENT_ID = "preview-list";

export const PreviewList: React.FC<Props> = ({
  open,
  loadingProducts,
  productsList,
  vendorsList,
  onViewAllProducts,
  onClose,
}) =>
  open ? (
    <ClickAwayListener
      onClickAway={(e) => {
        const SEARCH_TERM_INPUT_ID = "products-search";
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        e.target &&
          (e.target as HTMLElement).id !== SEARCH_TERM_INPUT_ID &&
          onClose();
      }}
    >
      <Paper
        id={COMPONENT_ID}
        elevation={8}
        style={{
          display: "flex",
          alignSelf: "center",
          width: "680px",
          minHeight: "420px",
          marginLeft: "-104px",
          padding: "16px",
          gap: "32px",
        }}
      >
        {loadingProducts ? (
          <Loading />
        ) : (
          <>
            <ProductsList
              items={productsList}
              onViewAllProducts={onViewAllProducts}
            />
            <VendorsList items={vendorsList} />
          </>
        )}
      </Paper>
    </ClickAwayListener>
  ) : (
    <></>
  );
